"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const sharing_1 = require("@completeanatomy/sharing");
const react_router_dom_1 = require("react-router-dom");
const organisms_1 = require("..");
function InviteNotification({ notification }) {
    var _a;
    const { name } = notification === null || notification === void 0 ? void 0 : notification.group;
    const { identifier } = notification === null || notification === void 0 ? void 0 : notification.membership;
    const navigate = (0, react_router_dom_1.useNavigate)();
    const sharingService = (0, sharing_1.useSharing)();
    const description = ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, i18n_1.Localized)(i18n_1.Strings.settings.notifications.invite), " ", name] }));
    const handleGroupJoin = () => {
        sharingService === null || sharingService === void 0 ? void 0 : sharingService.acceptGroup({ membershipId: identifier });
    };
    const handleDecline = () => {
        sharingService === null || sharingService === void 0 ? void 0 : sharingService.decline(identifier);
    };
    const openStore = () => {
        navigate('/store');
    };
    let buttons = [
        {
            icon: ui_1.Icons.Cross,
            title: (0, i18n_1.Localized)(i18n_1.Strings.common.decline),
            type: organisms_1.ButtonType.Flat,
            action: handleDecline,
            identifier: notification === null || notification === void 0 ? void 0 : notification.identifier,
        },
        {
            icon: ui_1.Icons.Group,
            title: (0, i18n_1.Localized)(i18n_1.Strings.settings.notifications.joinGroup),
            type: organisms_1.ButtonType.Secondary,
            action: handleGroupJoin,
            identifier: notification === null || notification === void 0 ? void 0 : notification.identifier,
        },
    ];
    // @ts-ignore - @todo replace
    if (!window.accessController.hasSharingPermission) {
        buttons = [
            {
                icon: ui_1.Icons.License_Badge,
                title: (0, i18n_1.Localized)(i18n_1.Strings.settings.notifications.buyLicense),
                type: organisms_1.ButtonType.Secondary,
                action: openStore,
                identifier: notification === null || notification === void 0 ? void 0 : notification.identifier,
                shouldDeleteOnAction: false,
            },
        ];
    }
    return ((0, jsx_runtime_1.jsx)(organisms_1.Notification, { isGroup: true, important: true, notification: notification, title: (_a = notification === null || notification === void 0 ? void 0 : notification.user) === null || _a === void 0 ? void 0 : _a.name, description: description, buttons: buttons, "data-e2e": 'InviteNotification_Notification' }));
}
exports.default = InviteNotification;
